<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('uNBLOCKIDCARD-details') }}</h1>
            </div>
        </v-flex>
        <!-- Add/Edit  UNBLOCKIDCARD -->
        <v-form class="flex xs12 mb-3" @submit.prevent="saveUNBLOCKIDCARD">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>

                        <v-flex md2 sm6 xs12 px-2>
                            <v-text-field :label="$t('national-number')" v-model="uNBLOCKIDCARD.beneficiaryNationalNumJOR" @change="getBenificiary($event)"></v-text-field>
                        </v-flex>

                        <v-flex md4 px-2 sm6 xs12>
                            <v-autocomplete :label="$t('beneficiary-info-management')"
                                            v-model="uNBLOCKIDCARD.beneficiaryinfomanagementid"
                                            :items="beneficiaryInfoManagementList"
                                            name="beneficiaryinfomanagementid"
                                            :item-text="getLabelByLang('fullName','fullName')"
                                            item-value="id"
                                            clearable
                                            @change="getBenificiarybyid()"
                                            :data-vv-as="$t('beneficiary-info-management')"
                                            :error-messages="errors.collect('beneficiaryinfomanagementid')"></v-autocomplete>
                        </v-flex>

                        <v-flex md3 sm6 xs12>
                            <v-menu ref="menu"
                                    v-model="datepickerMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <v-text-field slot="activator"
                                              v-model="uNBLOCKIDCARD.activationdate"
                                              :label="$t('ACTIVATIONDATE')+ ' *'"
                                              prepend-icon="event"
                                              readonly
                                              v-validate="'required'"
                                              :data-vv-as="$t('ACTIVATIONDATE')"
                                              :error-messages="errors.collect('activationdate')"
                                              name="activationdate"
                                              clearable></v-text-field>
                                <v-date-picker ref="picker"
                                               v-model="uNBLOCKIDCARD.activationdate"
                                               min="1900-01-01"
                                               @change="datepickerMenu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-checkbox :label="$t('ISACTIVEORNOT')"
                                        v-model="uNBLOCKIDCARD.isactiveornot"
                                        :data-vv-as="$t('ISACTIVEORNOT')"
                                        :error-messages="errors.collect('isactiveornot')"
                                        name="isactiveornot"
                                        ref="isactiveornot"></v-checkbox>
                        </v-flex>

                    </v-layout>
                    <v-btn color="primary" type="submit">{{ $t('unlocked') }}</v-btn>
                    <v-btn color="primary" :to="{ name: 'uNBLOCKIDCARD-list' }">{{ $t('cancel') }}</v-btn>
                </v-container>
            </v-card>
        </v-form>
    </v-layout>
</template>

<script>
    import UNBLOCKIDCARDService from '@/services/Disabilities/PersonWithDisabilities/UnblockIDCard/UNBLOCKIDCARDService';
    import BeneficiaryInformationManagementService from '@/services/Disabilities/PersonWithDisabilities/BeneficiaryInformationManagement/BeneficiaryInformationManagement/BeneficiaryInformationManagementService';

    export default {
        name: 'uNBLOCKIDCARD-details',
        data() {
            return {
                selected: [],
                // Filters
                uNBLOCKIDCARD: {
                    id: 0,
                    beneficiaryinfomanagementid: null,
                    activationdate: '',
                    isactiveornot: false,
                    beneficiaryNationalNumJOR: '',
                },
                beneficiaryInfoManagementList: [],
            };
        },

        async created() {
            /* to call the  Entities(drop down lists)  which are used in this Entity */
            await this.getBeneficiary();  /*get for Beneficiary */

            const uNBLOCKIDCARDId = this.$route.params.id;
            if (uNBLOCKIDCARDId) {
                /* add loading in edit mode */
                this.$store.dispatch('showLoading');
                const uNBLOCKIDCARD = (await UNBLOCKIDCARDService.getUNBLOCKIDCARD(uNBLOCKIDCARDId)).data;

                if (uNBLOCKIDCARD.activationdate) {
                    uNBLOCKIDCARD.activationdate = uNBLOCKIDCARD.activationdate.substr(0, 10);
                }

                this.$store.dispatch('hideLoading');
                if (!uNBLOCKIDCARD) this.$router.push({ name: 'uNBLOCKIDCARD-list' });
                this.uNBLOCKIDCARD = { ...this.uNBLOCKIDCARD, ...uNBLOCKIDCARD };
                this.getBenificiarybyid();
            }
        },

        methods: {
            async getBenificiary() {
                const beneficaryIndex = this.beneficiaryInfoManagementList.findIndex(
                    item => item.beneficiaryNationalNumJOR === this.uNBLOCKIDCARD.beneficiaryNationalNumJOR
                );
                if (beneficaryIndex !== -1) {
                    this.uNBLOCKIDCARD.beneficiaryinfomanagementid = this.beneficiaryInfoManagementList[beneficaryIndex].id;
                }
            },
            async getBenificiarybyid() {
                const beneficaryIndex = this.beneficiaryInfoManagementList.findIndex(
                    item => item.id === this.uNBLOCKIDCARD.beneficiaryinfomanagementid
                );
                if (beneficaryIndex !== -1) {
                    this.uNBLOCKIDCARD.beneficiaryNationalNumJOR = this.beneficiaryInfoManagementList[beneficaryIndex].beneficiaryNationalNumJOR;
                }
            },

            /* save Operation */
            async saveUNBLOCKIDCARD() {
                const isValid = await this.$validator.validateAll();
                if (isValid) {
                    /* add loading on save */
                    this.$store.dispatch('showLoading');
                    const result = await UNBLOCKIDCARDService.saveUNBLOCKIDCARD(this.uNBLOCKIDCARD);
                    if (result.data.statusCode === 200) {
                        this.$store.dispatch('showMessage', { text: result.data.message });
                        this.$router.push({ name: 'uNBLOCKIDCARD-list' });
                    } else {
                        this.$store.dispatch('showMessage', { text: result.data.message, color: 'error' });
                        this.$router.push({ name: 'uNBLOCKIDCARD-list', color: 'error' });
                    }
                    this.$store.dispatch('hideLoading');
                }
            },

            /* Get Operations */
            async getBeneficiary() {/* Get Beneficiary List Data*/
                this.beneficiaryInfoManagementList = (await BeneficiaryInformationManagementService.getBeneficiaryInformationManagements({
                    keyword: '',
                    beneficiaryNationalNumJOR: '',
                    nationalityLookUpCode: '',
                    fullName: '',
                    nameMUM: '',
                    nationalNumforMUM: '',
                    gender: '0',
                    socialStatus: '0',
                    educationalLevel: '0',
                    fatherNationalNo: '',
                    jobSector: '',
                    governorate: '',
                    aging: 0,
                    typeOfDisability: '',
                })).data;
            },
        }
    };
</script>